<script lang="ts">
export interface ButtonGroupProps {
  as?: string | Component
  size?: 'sm' | 'md' | 'lg'
  orientation?: 'horizontal' | 'vertical'
  class?: string | object
}

export interface ButtonGroupSlots {
  default: (props?: object) => any
}

export const buttonGroupVariantUi = {
  buttonGroup: {
    horizontal: 'not-only-child:first:rounded-e-none not-only-child:last:rounded-s-none not-last:not-first:rounded-none',
    vertical: 'not-only-child:first:rounded-b-none not-only-child:last:rounded-t-none not-last:not-first:rounded-none',
  },
}

// The root, not the inner element, sits in the group: its position decides which corners to square
export const buttonGroupVariantWithRootUi = {
  buttonGroup: {
    horizontal: {
      root: 'group',
      base: '[.group:first-child:not(:only-child)>&]:rounded-e-none [.group:last-child:not(:only-child)>&]:rounded-s-none [.group:not(:first-child):not(:last-child)>&]:rounded-none',
    },
    vertical: {
      root: 'group',
      base: '[.group:first-child:not(:only-child)>&]:rounded-b-none [.group:last-child:not(:only-child)>&]:rounded-t-none [.group:not(:first-child):not(:last-child)>&]:rounded-none',
    },
  },
}

const ui = {
  base: 'relative',
  variants: {
    orientation: {
      horizontal: 'inline-flex -space-x-px',
      vertical: 'inline-flex flex-col -space-y-px',
    },
  },
}
</script>

<script setup lang="ts">
import { Primitive } from 'reka-ui'
import { type Component, computed, provide } from 'vue'
import { buttonGroupInjectionKey } from '../composables/useButtonGroup'

const { orientation = 'horizontal', size = 'md', class: className } = defineProps<ButtonGroupProps>()

defineSlots<ButtonGroupSlots>()

provide(buttonGroupInjectionKey, computed(() => ({
  orientation,
  size,
})))
</script>

<template>
  <Primitive :as="as" :class="[className, ui.base, ui.variants.orientation[orientation]]">
    <slot />
  </Primitive>
</template>
